export default "__VITE_ASSET__DkY1uNiT__"